import React from "react";
import { Route, Routes } from "react-router-dom";
import { CaseDetailsContainer } from "./v1/index.container";

interface CredentialVerificationVersionRouterProps {
  isApplicantSection?: boolean;
}

export const CredentialVerificationVersionRouter: React.FC<
CredentialVerificationVersionRouterProps
> = (props) => {
  return (
    <Routes>
      <Route
        path="v1/*"
        element={<CaseDetailsContainer isApplicantSection={props.isApplicantSection}/>}
      />
    </Routes>
  );
};
